import * as THREE from 'three';
import { axialToWorld } from '@/game/hexmap';
import config from '@/game/hexmap/config';
import { useSimFrame } from './app/simFrame';
import { flatRing, InstancedMarkers, type MarkerPoint } from './InstancedMarkers';
import { type UiStore, useUi } from './ui/store';

const MARKER_Y = config.hexMap.tile.thickness + 0.1;

const ringGeometry = flatRing(0.5, 0.05, 32);
// --color-accent: three can't read CSS tokens.
const ringMaterial = new THREE.MeshStandardMaterial({
  color: '#7dd3fc',
  emissive: '#7dd3fc',
  emissiveIntensity: 1.1,
});

/**
 * Rings on the units and buildings an upgrade card points at while it is hovered
 * (`ui.highlightIds`), on the tile each stands on. Does nothing (and doesn't
 * follow the sim frame) while nothing is highlighted.
 */
export function HighlightMarkers({ ui }: { ui: UiStore }) {
  const ids = useUi(ui, (s) => s.highlightIds);
  return ids.length > 0 ? <Rings ids={ids} /> : null;
}

function Rings({ ids }: { ids: readonly string[] }) {
  const { view: state } = useSimFrame();
  const points: MarkerPoint[] = [];
  for (const id of ids) {
    const at = state.units[id] ?? state.buildings[id];
    if (!at) continue;
    const world = axialToWorld(at.pos, config.hexMap.tile.radius);
    points.push({ x: world.x, y: MARKER_Y, z: world.z });
  }
  return <InstancedMarkers geometry={ringGeometry} material={ringMaterial} points={points} />;
}
